var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection_banner"},[_c('img',{staticClass:"opacity",attrs:{"src":_vm.returnBannerImage()}}),_c('div',{staticClass:"banner_info"},[_c('div',{staticClass:"banner_user"},[_vm._v(" "+_vm._s(_vm.returnWriter().mb_nick)+" gallery ")]),_c('div',{staticClass:"banner_subject"},[_vm._v(" "+_vm._s(_vm.galleryData.c_title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }